import React from 'react';
import { resolveAvatarUrl } from '../../utils/resolveAvatarUrl';

const AVATAR_COLORS = ['#E8D5B7', '#D5C4A1', '#F0D9B5', '#C7B299', '#DEC8A8', '#B8C4D0'];

export const getMessengerInitials = (name = '') => {
  const words = `${name}`.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  return words.slice(0, 2).map((word) => word[0]).join('').toUpperCase();
};

export const getMessengerAvatarColor = (name = '') => {
  const seed = `${name}`.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return AVATAR_COLORS[seed % AVATAR_COLORS.length];
};

export const getMessengerGroupMeta = (messages = [], index = 0, resolveSenderKey = () => null) => {
  const currentMessage = messages[index];
  if (!currentMessage) {
    return { previousSameSender: false, nextSameSender: false, groupPosition: 'single' };
  }

  const currentSenderKey = resolveSenderKey(currentMessage);
  const previousSenderKey = index > 0 ? resolveSenderKey(messages[index - 1]) : null;
  const nextSenderKey = index < messages.length - 1 ? resolveSenderKey(messages[index + 1]) : null;
  const previousSameSender = Boolean(currentSenderKey && previousSenderKey && currentSenderKey === previousSenderKey);
  const nextSameSender = Boolean(currentSenderKey && nextSenderKey && currentSenderKey === nextSenderKey);

  let groupPosition = 'single';
  if (!previousSameSender && nextSameSender) groupPosition = 'first';
  else if (previousSameSender && nextSameSender) groupPosition = 'middle';
  else if (previousSameSender && !nextSameSender) groupPosition = 'last';

  return { previousSameSender, nextSameSender, groupPosition };
};

export const MessengerAvatar = ({
  name,
  imageUrl,
  size = 56,
  textSize = 18,
  online = false,
  extraBadge = null,
  dataTestId,
}) => {
  const initials = getMessengerInitials(name);
  const resolvedImageUrl = resolveAvatarUrl(imageUrl);

  return (
    <div data-testid={dataTestId} style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          overflow: 'hidden',
          backgroundColor: getMessengerAvatarColor(name),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px solid var(--app-bg)',
          boxShadow: 'var(--premium-shadow-nested)',
        }}
      >
        {resolvedImageUrl ? (
          <img src={resolvedImageUrl} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <span style={{ fontFamily: "'Inria Serif', serif", fontSize: textSize, fontWeight: 700, color: 'var(--text-2)' }}>{initials}</span>
        )}
      </div>

      {online ? (
        <div
          style={{
            position: 'absolute',
            bottom: 2,
            right: -2,
            width: 12,
            height: 12,
            borderRadius: '50%',
            background: 'var(--status-success-text)',
            border: '2px solid #fff',
          }}
        />
      ) : null}

      {extraBadge ? <div style={{ position: 'absolute', bottom: -4, left: -4 }}>{extraBadge}</div> : null}
    </div>
  );
};